import { registerAsset, AssetAriaLabel, DEFAULT_MIN_ASSET_WIDTH } from 'owa-timestream-asset-sdk';
import { DefaultCommand } from 'owa-timestream-asset-sdk-types';
import type { PeoplePayload } from './schema';
import PeopleView from './components/PeopleView';
import { peopleAssetName, peopleAssetTooltip, assertErrorPeople } from './people.locstring.json';
import loc from 'owa-localize';
import { ControlIcons } from 'owa-control-icons';

const PEOPLE_TYPE = 'people';

export default registerAsset<PeoplePayload>({
    type: PEOPLE_TYPE,
    iconName: ControlIcons.Contact,
    getToolName: () => loc(peopleAssetName),
    getTooltip: () => loc(peopleAssetTooltip),
    getErrorMessage: () => loc(assertErrorPeople),
    unsupportedDefaultCommands: [DefaultCommand.DueDate],
    CanvasView: PeopleView,
    createEmptyAsset: () => ({
        type: PEOPLE_TYPE,
        width: DEFAULT_MIN_ASSET_WIDTH,
        payload: { selectedPerson: undefined },
    }),
    getAriaLabel: (payload: PeoplePayload) => {
        if (!payload.selectedPerson) {
            return loc(peopleAssetName);
        }
        return loc(AssetAriaLabel.assetAriaLabel, loc(peopleAssetName), getPeopleName(payload));
    },
    getSearchString: getPeopleName,
    getTitleString: getPeopleName,
});

function getPeopleName(payload: PeoplePayload) {
    return payload?.selectedPerson?.EmailAddress?.Name;
}
